import { TicketAdmin } from "./TicketAdmin";

export default {
    list: TicketAdmin,
};

